export const getQueryParameter = (query: string, parameter: string) =>
  new URLSearchParams(query).get(parameter);
